import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { ManagerService } from "../../../core/services/manager.service";
import { Observable } from "rxjs";
import { map, pluck, switchMap, take } from "rxjs/operators";

@Component({
  selector: "app-lobby-sub-menu",
  templateUrl: "./lobby-sub-menu.component.html",
  styleUrls: ["./lobby-sub-menu.component.scss"],
})
export class LobbySubMenuComponent implements OnInit {
  @Input() selectedGameType: string = "";
  @Input() design: string = "newDesign";

  @Output() gameTypeChange = new EventEmitter<string>();
  @Output() holdemLimitChange = new EventEmitter<string>();
  @Output() omahaChange = new EventEmitter<string>();

  gameFilters$: Observable<any>;

  constructor(private managerService: ManagerService) {}

  ngOnInit() {
    this.gameFilters$ = this.managerService.lobbyFilter$.pipe(
      take(1),
      pluck("filters"),
      switchMap((lobbyFilterOptions) =>
        this.managerService.tableFilters$.pipe(
          map((tableFilters) => {
            if (tableFilters) {
              if (lobbyFilterOptions.TableType === 1) {
                return tableFilters.RingFilters;
              }
              if (lobbyFilterOptions.TableType === 2) {
                return tableFilters.SitNGoFilters;
              }
              if (lobbyFilterOptions.TableType === 4) {
                return tableFilters.TournamentFilters;
              }
              if (lobbyFilterOptions.TableType === 16) {
                return tableFilters.SpinNGoFilters;
              }
            }

            return {};
          }),
        ),
      )
    );
  }

  onChange(value: string) {
    this.gameTypeChange.emit(value);
  }

  onHoldemLimit(value: string) {
    this.holdemLimitChange.emit(value);
  }

  onOmaha(value: string) {
    this.omahaChange.emit(value);
  }
}
